module.exports = __webpack_public_path__ + "static/img/biaozhi.e9229233.png";